import h from './htm';
import domWrap from './domWrap';
import { iOS } from '../constants';

const 	slideOuts = {},
		duration = 500;

function wait(ms,complete,canceled){
	var timeout = {
		timer: setTimeout(complete,ms),
		clear: function(){
			clearTimeout(timeout.timer);
			canceled();
		}
	};
	return timeout;
}

function show(id){
	const 	slideOut = slideOuts[id];
	return new Promise((resolve, reject) => {
		if(!slideOut.element){
			render(id);
			slideOut.active = wait(60,function(){
				slideOut.element.classList.add('slide-open');
				slideOut.boundTo.classList.add('push-' + slideOut.direction);
				if(slideOut.className !== ''){
					slideOut.boundTo.classList.add('off-canvas-' + slideOut.className);
				}
				slideOut.active = wait(duration,function(){
					slideOut.active = undefined;
					resolve();
					slideOut.element.classList.add('slide-opened');
					slideOut.visible = true;
				},reject);
				cover(id,true);
			},reject);
		}
		else {
			resolve();
		}
	});
}

function hide(id){
	const 	slideOut = slideOuts[id];
	return new Promise((resolve, reject) => {
		if(slideOut.element){
			slideOut.element.classList.remove('slide-open','slide-opened')
			slideOut.boundTo.classList.remove('push-'+ slideOut.direction);
			if(slideOut.className !== ''){
				slideOut.boundTo.classList.remove('off-canvas-' + slideOut.className);
			}
			slideOut.active = wait(duration,() => {
				remove(id);
				slideOut.active = slideOut.element = undefined;
				slideOut.visible = false;
				resolve();
			},reject);
			cover(id);
		}
		else {
			resolve();
		}	
	});
}

function cover(id,show){
	const 	slideOut = slideOuts[id];
	if(show){
		slideOut.cover = slideOut.cover || h(`div class="off-canvas-cover" data-id="${id}"`).Node;
		if(!slideOut.boundTo.querySelector(`:scope .off-canvas-cover[data-id="${id}"]`)){
			slideOut.boundTo.prepend(slideOut.cover);
			domWrap(slideOut.cover).addEventListener('click',()=>hide(id));
		}
		wait(0,() => slideOut.cover.classList.add('show'));
	}
	else {
		slideOut.cover.classList.remove('show');
		wait(duration,() => {
			slideOut.cover.remove();
			slideOut.cover = undefined;
		});
	}
}

function render(id,reverse){
	const 	slideOut = slideOuts[id],
			contentLen = slideOut.content.length,
			contentItem = slideOut.content[contentLen - 1],
			content = h('div',contentItem[0]).Node;

	slideOut.element = slideOut.element || h(`div data-id="${id}" class="off-canvas ${slideOut.direction} ${slideOut.className}"`).Node;


	if(reverse){
		slideOut.element.classList.add('reverse');
	}

	if(slideOut.element.querySelector(':scope > div')){
		[...slideOut.element.querySelectorAll(':scope > div')].forEach(element => element.classList.add('out'));
		content.classList.add('in');
	}

	if(!slideOut.boundTo.querySelector('.off-canvas[data-id="'+id+'"]')){
		slideOut.boundTo.prepend(slideOut.element);
	}

	slideOut.element.append(content);

	if(contentItem[1]){
		contentItem[1](content);
	}

	slideOut.switchActive = wait(0,() => {
		content.classList.remove('in');
		slideOut.switchActive = wait(duration,() => {
			slideOut.switchActive = undefined;
			[...slideOut.element.querySelectorAll('.out')].forEach(element => element.remove());
			slideOut.element.classList.remove('reverse');
		});
	});
}

function remove(id){
	slideOuts[id].element.remove();
}

function hideAll(){
	return new Promise(resolve => {
		Promise.all(Object.keys(slideOuts).map(id=>hide(id))).then(resolve);	
	});
}

function offCanvas({boundTo = document.body, direction = 'left', className = ''} = {}){
	const _id = (Math.random() * 100000) + '-' + Date.now(),
			exports = {
				destroy(){
					return new Promise(resolve => {
						hide(_id).then(()=>{
							delete slideOuts[_id];
							resolve();
						});
					});
				},
				show(){
					return new Promise(resolve => {
						if(!slideOuts[_id].element){
							// Hide all others first
							hideAll().then(() => show(_id).then(resolve));
						}
						else {
							resolve();
						}
					});
				},
				hide(){
					return new Promise(resolve => hide(_id).then(resolve));
				},
				content(content,binder){
					slideOuts[_id].content.push([content,binder]);
					if(slideOuts[_id].visible){
						render(_id);
					}
					return exports;
				},
				back(){
					slideOuts[_id].content.pop();
					if(slideOuts[_id].visible){
						render(_id,true);
					}
					return exports;
				}
			};

	slideOuts[_id] = {
		content: [],
		visible: false,
		active: undefined,
		switchActive: undefined,
		element: undefined,
		boundTo,
		direction: iOS ? 'right' : direction,
		className
	};

	return exports;
}

export default offCanvas;


// (function ( $ ) {

// 	var slideOuts = {},
// 		// deskDur = 500,
// 		duration = 500;

// 	function wait(ms,complete,canceled){
// 		var timeout = {
// 			timer: setTimeout(complete,ms),
// 			clear: function(){
// 				clearTimeout(timeout.timer);
// 				canceled();
// 			}
// 		};
// 		return timeout;
// 	}

// 	function attachTouch(id){
// 		var lastPos = false,
// 			slideOut = slideOuts[id],
// 			nav = slideOut.element;
// 		if(!nav.attr('touched') && false){
// 			nav.attr('touched',true);
// 			nav.on('touchend',function(e){
// 				lastPos = false
// 			});
// 			nav.on('touchmove',function(e){
// 				e.preventDefault();
// 				var pageY = e.originalEvent.pageY,
// 					delta = lastPos === false ? 0 : lastPos - pageY;

// 				lastPos = pageY;

// 				nav.find('> div').scrollTop(nav.find('> div').scrollTop() + delta);
// 				//console.log(delta);
// 			});
// 		}

// 	}

// 	function show(id){
// 		var deferred = $.Deferred(),
// 			slideOut = slideOuts[id];

// 		if(!slideOut.element){
// 			render(id);
			
// 			slideOut.active = wait(60,function(){
// 				slideOut.element.addClass('slide-open');
// 				slideOut.boundTo.addClass('push-' + slideOut.direction);
// 				if(slideOut.className !== ''){
// 					slideOut.boundTo.addClass('off-canvas-' + slideOut.className);
// 				}
				
// 				//slideOut.boundTo.on("touchstart", touchMoved);
// 				slideOut.active = wait(duration,function(){
// 					slideOut.active = undefined;
// 					deferred.resolve();
// 					slideOut.element.addClass('slide-opened');
// 					slideOut.visible = true;
// 					// if($(window).width() < 768){
// 					// 	if($('body').data('plugin_panelSnap')){
// 					// 		$('body').data('plugin_panelSnap').enabled = false;
// 					// 	}
// 					// 	wait(60,function(){
// 					// 		slideOut.scrollPos = $(window).scrollTop();
// 					// 		$(window).scrollTop(0);
// 					// 	})
						
// 					// }
// 				},deferred.reject);
// 				cover(id,true);
// 			},deferred.reject);

// 		}
// 		else {
// 			deferred.resolve();
// 		}

// 		return deferred;
// 	}

// 	function hide(id){
// 		var deferred = $.Deferred(),
// 			slideOut = slideOuts[id];
// 		if(slideOut.element){
// 			// if($('body').data('plugin_panelSnap')){
// 			// 	delete $('body').data('plugin_panelSnap').enabled;
// 			// }
// 			// if(slideOut.scrollPos){
// 			// 	$('html,body').scrollTop(slideOut.scrollPos);

// 			// 	slideOut.scrollPos = false;
// 			// }
// 			slideOut.element.removeClass('slide-open').removeClass('slide-opened');
// 			slideOut.boundTo.removeClass('push-'+ slideOut.direction);
// 			if(slideOut.className !== ''){
// 				slideOut.boundTo.removeClass('off-canvas-' + slideOut.className);
// 			}
// 			//slideOut.boundTo.off("touchstart", touchMoved);
// 			slideOut.active = wait(duration,function(){
// 				remove(id);
// 				slideOut.active = slideOut.element = undefined;
// 				slideOut.visible = false;
// 				deferred.resolve();
// 			},deferred.reject);
// 			cover(id);
// 		}
// 		else {
// 			deferred.resolve();
// 		}

// 		return deferred;

// 	}

// 	function cover(id,show){
// 		var slideOut = slideOuts[id];


// 		if(show){
// 			slideOut.cover = slideOut.cover || $('<div class="off-canvas-cover" data-id="'+id+'"></div>');
// 			if(!slideOut.boundTo.find('.off-canvas-cover[data-id="'+id+'"]').length){
// 				slideOut.boundTo.prepend(slideOut.cover);
// 				slideOut.cover.on('click',function(){
// 					hide(id);
// 				});
// 			}
// 			wait(0,function(){
// 				slideOut.cover.addClass('show');
// 			});
// 		}
// 		else {
// 			slideOut.cover.removeClass('show');
// 			wait(duration,function(){
// 				slideOut.cover.remove();
// 				slideOut.cover = undefined;
// 			});
// 		}
// 	}

// 	function render(id,reverse){
// 		var slideOut = slideOuts[id],
// 			contentLen = slideOut.content.length,
// 			contentItem = slideOut.content[contentLen - 1],
// 			content = $('<div>'+contentItem[0]+'</div>');

// 		slideOut.element = slideOut.element || $('<div data-id="'+id+'" class="off-canvas '+slideOut.direction+' '+slideOut.className+'"></div>');

// 		attachTouch(id);

// 		if(reverse){
// 			slideOut.element.addClass('reverse');
// 		}

// 		if(slideOut.element.children('div')[0]){
// 			slideOut.element.children('div').addClass('out');
// 			content.addClass('in');
// 		}

// 		if(!slideOut.boundTo.find('.off-canvas[data-id="'+id+'"]').length){
// 			slideOut.boundTo.prepend(slideOut.element);
// 		}

// 		slideOut.element.append(content);

// 		if(contentItem[1]){
// 			contentItem[1](content);
// 		}

// 		// slideOut.element.animate({
// 		// 	scrollTop: 0
// 		// }, 800);

// 		slideOut.switchActive = wait(0,function(){
// 			content.removeClass('in');
// 			slideOut.switchActive = wait(duration,function(){
// 				slideOut.switchActive = undefined;
// 				slideOut.element.children('.out').remove();
// 				slideOut.element.removeClass('reverse');
// 			});
// 		});
// 	}

// 	function remove(id){
// 		slideOuts[id].element.remove();
// 	}

// 	function hideAll(){
// 		var deferred = $.Deferred();
// 		$.when.apply($,Object.keys(slideOuts).reduce(function(array,current){
// 			return array.concat(hide(current));
// 		},[])).done(deferred.resolve);
// 		return deferred;
// 	}


// 	$.fn.offCanvas = function(options) {
// 		var _id = (Math.random() * 100000) + '-' + Date.now(),
// 			boundTo = this,
// 			iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

// 		if(iOS){
// 			options.direction = 'right';
// 		}

// 		var exports = {
// 			destroy: function(){
// 				var deferred = $.Deferred();
// 				hide(_id).done(function(){
// 					delete slideOuts[_id];
// 					deferred.resolve();
// 				});
// 				return deferred;
// 			},
// 			show: function(){
// 				var deferred = $.Deferred();
// 				if(!slideOuts[_id].element){
// 					// Hide all others first
// 					hideAll().done(function(){
// 						show(_id).done(deferred.resolve);
// 					});
// 				}
// 				else {
// 					deferred.resolve();
// 				}
// 				return deferred;
// 			},
// 			hide: function(){
// 				var deferred = $.Deferred();
// 				hide(_id).done(deferred.resolve);
// 				return deferred;
// 			},
// 			content: function(content,binder){
// 				slideOuts[_id].content.push([content,binder]);
// 				if(slideOuts[_id].visible){
// 					render(_id);
// 				}
// 				return exports;
// 			},
// 			back: function(){
// 				slideOuts[_id].content.pop();
// 				if(slideOuts[_id].visible){
// 					render(_id,true);
// 				}
// 				return exports;
// 			}
// 		};

// 		options = options || {};

// 		slideOuts[_id] = {
// 			content: [],
// 			visible: false,
// 			active: undefined,
// 			switchActive: undefined,
// 			element: undefined,
// 			boundTo: boundTo,
// 			direction: options.direction || 'left',
// 			className: options.className || ''
// 		};

// 		return exports;
// 	};
 
//  	// updateDuration();
//  	// $(window).on('resize',updateDuration);
// }( jQuery ));